import {PDFInfo} from "../../../../misc/pdf/PrintManager";
import {Company} from "../../../../api/Companies";
import {Opening} from "../../../../api/Openings";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {Project, UnitSystem} from "../../../../api/Projects";
import {OpeningSizePDF} from "./OpeningSizePDF";
import {ExportColumn} from "../openings/MakeSubmittal";
import {Contact} from "../../../../api/Contacts";

export type OpeningSizeSubData = {
    client?: Company;
    clientContact?: Contact;
    data: (Opening|QuoteOpening)[]
    project: Project;
    sys: UnitSystem;
    columns: ExportColumn[]
    wallTypeImages: string[];
    anchorImages: string[];
}

export function getOpeningSizeSubmittal(props: {
    projectId: number;
    getData(): Promise<OpeningSizeSubData>
}): PDFInfo {
    return {
        name: "opening-size-submittal.pdf",
        render: async (onReady, config) => {
            const d = await props.getData();

            return (
                <OpeningSizePDF
                    onReady={onReady}
                    client={d.client}
                    clientContact={d.clientContact}
                    data={d.data}
                    project={d.project}
                    sys={d.sys}
                    columns={d.columns}
                    wallTypeImages={d.wallTypeImages}
                    anchorImages={d.anchorImages}
                />
            )
        },
        serverInfo: {
            submissionForProject: props.projectId,
            submissionType: "frame-openings",
        }
    }
}